import { createContext } from 'react';
import type { CreatePolicyStore } from './CreatePolicyStore';

export const CreatePolicyStoreContext = createContext<CreatePolicyStore | null>(
	null
);
